import { ReactNode } from "react";
import { RadioButton, RadioButtonProps } from "./RadioButton";

type RadioCardProps = RadioButtonProps & {
  children?: ReactNode;
};
export const RadioCard = (props: RadioCardProps) => {
  const { children, ...rest } = props;
  const extraClass = rest.isSelected ? "radio-card-selected" : "";
  return (
    <div className={`radio-card ${extraClass}`.trim()}>
      <RadioButton {...rest} />
      <div className="body">{props.children}</div>
    </div>
  );
};
